import React, { useRef, useEffect, useState } from 'react';
import gsap from 'gsap';
import { useNavigate } from 'react-router-dom';

import asterisk from '../asserts/as.png';
import './login.css';
import '../root.css';
import Preloader from '../components/layout/preloader';
import Btn from '../components/common/btn';

const Login = () => {
    const containerRef = useRef(null);
    const sunburstRef = useRef(null);
    const titleRef = useRef(null);
    const subtitleRowRef = useRef(null);
    const field1Ref = useRef(null);
    const field2Ref = useRef(null);
    const forgotRef = useRef(null);
    const btnRef = useRef(null);
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const tl = gsap.timeline({ defaults: { ease: 'power4.out' } });

        gsap.set(containerRef.current, { opacity: 0 });
        gsap.set(sunburstRef.current, { opacity: 0, scale: 1.3, y: -40 });
        gsap.set(titleRef.current, { opacity: 0, x: -60, skewX: 8 });
        gsap.set(subtitleRowRef.current, { opacity: 0, scaleX: 0.4 });
        gsap.set(field1Ref.current, { opacity: 0, x: 50 });
        gsap.set(field2Ref.current, { opacity: 0, x: 50 });
        gsap.set(forgotRef.current, { opacity: 0, y: 10 });
        gsap.set(btnRef.current, { opacity: 0, y: 40, scale: 0.92 });

        tl.to(containerRef.current, { opacity: 1, duration: 0.3 })
          .to(sunburstRef.current, { opacity: 1, scale: 1, y: 0, duration: 1.1 }, '-=0.1')
          .to(titleRef.current, { opacity: 1, x: 0, skewX: 0, duration: 0.8 }, '-=0.6')
          .to(subtitleRowRef.current, { opacity: 1, scaleX: 1, duration: 0.6, ease: 'expo.out' }, '-=0.4')
          .to(field1Ref.current, { opacity: 1, x: 0, duration: 0.55 }, '-=0.2')
          .to(field2Ref.current, { opacity: 1, x: 0, duration: 0.55 }, '-=0.35')
          .to(forgotRef.current, { opacity: 1, y: 0, duration: 0.4 }, '-=0.2')
          .to(btnRef.current, { opacity: 1, y: 0, scale: 1, duration: 0.6, ease: 'back.out(1.4)' }, '-=0.2');
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email || !password) {
            setError('All fields are required.');
            return;
        }
        if (email === 'raia@gmail.com' && password === '123') {
            setError('');
            navigate('/onboarding1');
        } else {
            setError('Incorrect email or password. Please try again.');
        }
    };

    return (
        <>
            <Preloader />
            <div className="home-wrapper">
                <div className="mobile-container" ref={containerRef}>
                    <main className="login-screen">

                        <div className="sunburst-area" ref={sunburstRef} aria-hidden="true">
                            <img src={asterisk} alt="" className="sunburst-img" />
                        </div>

                        <div className="login-content">
                            <header className="login-heading">
                                <h1 className="login-title" ref={titleRef}>WELCOME<br />BACK</h1>
                                <div className="login-subtitle-row" ref={subtitleRowRef}>
                                    <span className="subtitle-line" aria-hidden="true" />
                                    <p className="login-subtitle">Sign in to continue your design journey</p>
                                    <span className="subtitle-line" aria-hidden="true" />
                                </div>
                            </header>

                            <form className="login-form" onSubmit={handleSubmit}>
                                <div className="field-group" ref={field1Ref}>
                                    <label className="field-label" htmlFor="login-email">
                                        <span className="label-dot" aria-hidden="true">*</span>EMAIL ADDRESS
                                    </label>
                                    <div className="field-input-wrap">
                                        <span className="field-icon">
                                            <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                                <rect x="2" y="4" width="20" height="16" rx="2"/>
                                                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                                            </svg>
                                        </span>
                                        <input
                                            id="login-email"
                                            type="email"
                                            placeholder="your.email@example.com"
                                            className="field-input"
                                            required
                                            aria-required="true"
                                            value={email}
                                            onChange={(e) => { setEmail(e.target.value); setError(''); }}
                                        />
                                    </div>
                                </div>

                                <div className="field-group" ref={field2Ref}>
                                    <label className="field-label" htmlFor="login-password">
                                        <span className="label-dot" aria-hidden="true">*</span>PASSWORD
                                    </label>
                                    <div className="field-input-wrap">
                                        <span className="field-icon">
                                            <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                                                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                                            </svg>
                                        </span>
                                        <input
                                            id="login-password"
                                            type={showPassword ? 'text' : 'password'}
                                            placeholder="Enter your password"
                                            className="field-input"
                                            required
                                            aria-required="true"
                                            value={password}
                                            onChange={(e) => { setPassword(e.target.value); setError(''); }}
                                        />
                                        <button
                                            type="button"
                                            className="eye-btn"
                                            onClick={() => setShowPassword(s => !s)}
                                            aria-label={showPassword ? "Hide password" : "Show password"}
                                        >
                                            <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                                                <circle cx="12" cy="12" r="3"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                                {error && <p className="login-error">{error}</p>}

                                <div className="forgot-row" ref={forgotRef}>
                                    <button type="button" className="forgot-btn" aria-label="Recover your forgotten password">
                                        Forgot Password? <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M5 12h14M12 5l7 7-7 7"/>
                                        </svg>
                                    </button>
                                </div>

                                <div className="sign-in-wrap" ref={btnRef} onClick={handleSubmit}>
                                    <Btn btnt="SIGN IN" />
                                </div>
                            </form>
                        </div>

                    </main>
                </div>
            </div>
        </>
    );
};

export default Login;